// ---------------------------------------------- modules import
import { IOrderedAlbum } from "../firebase/common";
import firebase from "../../config/fbInit";

export interface ICreator {
  email: string;
  name: string;
}

export interface IAlbum extends IOrderedAlbum {
  [key: string]: any;
}

const newCreator = (): ICreator => ({
  email: "",
  name: ""
});

export const newAlbum = (creator?: ICreator): IOrderedAlbum => ({
  id: "",
  createdAt: firebase.firestore.Timestamp.now(),
  creator: creator ? creator : newCreator(),
  lastModified: firebase.firestore.Timestamp.now(),
  link: "",
  name: ""
});

// ---------------------------------------------- state interface
export interface IAlbumState {
  loading: boolean;
  error: string | null;
}

// ---------------------------------------------- action type enum
export enum AlbumActionType {
  ADD_ALBUM_BEGIN = "ADD_ALBUM_BEGIN",
  ADD_ALBUM_SUCCESS = "ADD_ALBUM_SUCCESS",
  ADD_ALBUM_ERROR = "ADD_ALBUM_ERROR",
  UPDATE_ALBUM_BEGIN = "UPDATE_ALBUM_BEGIN",
  UPDATE_ALBUM_SUCCESS = "UPDATE_ALBUM_SUCCESS",
  UPDATE_ALBUM_ERROR = "UPDATE_ALBUM_ERROR",
  DELETE_ALBUM_BEGIN = "DELETE_ALBUM_BEGIN",
  DELETE_ALBUM_SUCCESS = "DELETE_ALBUM_SUCCESS",
  DELETE_ALBUM_ERROR = "DELETE_ALBUM_ERROR"
}

// ---------------------------------------------- action interfaces
interface IAddBegin {
  type: typeof AlbumActionType.ADD_ALBUM_BEGIN;
}

interface IAddSuccess {
  type: typeof AlbumActionType.ADD_ALBUM_SUCCESS;
}

interface IAddError {
  type: typeof AlbumActionType.ADD_ALBUM_ERROR;
  payload: {
    error: string;
  };
}

interface IUpdateBegin {
  type: typeof AlbumActionType.UPDATE_ALBUM_BEGIN;
}

interface IUpdateSuccess {
  type: typeof AlbumActionType.UPDATE_ALBUM_SUCCESS;
}

interface IUpdateError {
  type: typeof AlbumActionType.UPDATE_ALBUM_ERROR;
  payload: {
    error: string;
  };
}

interface IDeleteBegin {
  type: typeof AlbumActionType.DELETE_ALBUM_BEGIN;
}

interface IDeleteSuccess {
  type: typeof AlbumActionType.DELETE_ALBUM_SUCCESS;
}

interface IDeleteError {
  type: typeof AlbumActionType.DELETE_ALBUM_ERROR;
  payload: {
    error: string;
  };
}

// ---------------------------------------------- exported action type
export type AlbumAction =
  | IAddBegin
  | IAddSuccess
  | IAddError
  | IUpdateBegin
  | IUpdateSuccess
  | IUpdateError
  | IDeleteBegin
  | IDeleteSuccess
  | IDeleteError;
